// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.loader_loadercontainer__CRvwb {


    position: fixed;
    height: 100%;
    width: 100%;
    top: 0;
    left: 0;
    opacity: 1;
    background-color: #29355d8a;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    will-change: opacity;
    transform: translateZ(0px);
    transition: left 0ms cubic-bezier(0.23, 1, 0.32, 1) 0ms, opacity 400ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;
    z-index: 1000;
    /* //z-index: 1400; */
  
  }
    `, "",{"version":3,"sources":["webpack://./src/component/commonComponent/loader.module.css"],"names":[],"mappings":"AAAA;;;IAGI,eAAe;IACf,YAAY;IACZ,WAAW;IACX,MAAM;IACN,OAAO;IACP,UAAU;IACV,2BAA2B;IAC3B,6CAA6C;IAC7C,oBAAoB;IACpB,0BAA0B;IAC1B,yGAAyG;IACzG,aAAa;IACb,qBAAqB;;EAEvB","sourcesContent":[".loadercontainer {\r\n\r\n\r\n    position: fixed;\r\n    height: 100%;\r\n    width: 100%;\r\n    top: 0;\r\n    left: 0;\r\n    opacity: 1;\r\n    background-color: #29355d8a;\r\n    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\r\n    will-change: opacity;\r\n    transform: translateZ(0px);\r\n    transition: left 0ms cubic-bezier(0.23, 1, 0.32, 1) 0ms, opacity 400ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;\r\n    z-index: 1000;\r\n    /* //z-index: 1400; */\r\n  \r\n  }\r\n    "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"loadercontainer": `loader_loadercontainer__CRvwb`
};
export default ___CSS_LOADER_EXPORT___;
